/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 202309d9 (Tue Mar 17 17:42:15 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
/**
 *
 * @export
 * @interface Region
 */
export interface Region {
  /**
   * The unique identifier assigned by the system when a region is first created.
   * @type number
   * @memberof Region
   */
  regionsKey: number
  /**
   * The name assigned to the region. This is required for region creation.
   * @type string
   * @memberof Region
   */
  name: string
  /**
   * The currency code used for the region. ISO-4217 standard codes.
   * @type string
   * @memberof Region
   */
  currency: string
  /**
   * A number indicating which set of curriculum a region is using.
   * @type number
   * @memberof Region
   */
  cycle?: number
  /**
   * The number indicating the month semester one begins. Indexed from 0 to 11. This is required for creation.
   * @type number
   * @memberof Region
   */
  semesterOneStartMonth: number
  /**
   * The number indicating the day semester one begins. This is required for creation.
   * @type number
   * @memberof Region
   */
  semesterOneStartDay: number
  /**
   * The number indicating the month semester two begins. Indexed from 0 to 11. This is required for creation.
   * @type number
   * @memberof Region
   */
  semesterTwoStartMonth: number
  /**
   * The number indicating the day semester two begins. This is required for creation.
   * @type number
   * @memberof Region
   */
  semesterTwoStartDay: number
  /**
   * The unique identifier of the region that is a parent of this region. This is required for creation.
   * @type number
   * @memberof Region
   */
  parentRegionsKey?: number
  /**
   * The name of the region that is a parent of this region.
   * @type string
   * @memberof Region
   */
  parentRegionName?: string
  /**
   * Boolean indicating if the programs and communities under this region should show up in public searches, such as 'Community Search'.
   * @type boolean
   * @memberof Region
   */
  isPrivate: boolean
  /**
   * The actor assigned as the region manager. This is required for creation.
   * @type number
   * @memberof Region
   */
  actorKey?: number
  /**
   * The name of the user managing this region
   * @type string
   * @memberof Region
   */
  regionManagerName: string
  /**
   * Boolean indicating if the external automated contracting process within the 'Add a Team Member' process should be bypassed.
   * @type boolean
   * @memberof Region
   */
  bypassAutomatedAgreements: boolean
  /**
   * Link to discourse forums url
   * @type string
   * @memberof Region
   */
  discourseUrl: string
  /**
   * A year when cycle 1 starts
   * @type number
   * @memberof Region
   */
  aYCycleStartYear: number
  /**
   * Boolean indicating if ach payments are allowed for the region
   * @type boolean
   * @memberof Region
   */
  achAllowed?: boolean
  /**
   * Days before semester one start date when the color of licensing due change to NORMAL
   * @type number
   * @memberof Region
   */
  s1LicensingDueOffset: number
  /**
   * Days after semester one start date when the color of licensing due change to RED
   * @type number
   * @memberof Region
   */
  s1LicensingLateOffset: number
  /**
   * Days before semester two start date when the color of licensing due change to NORMAL
   * @type number
   * @memberof Region
   */
  s2LicensingDueOffset: number
  /**
   * Days before semester two start date when the color of licensing due change to RED
   * @type number
   * @memberof Region
   */
  s2LicensingLateOffset: number
  /**
   * A multiplier value used to calculate what Country Coordinator owes CC
   * @type string
   * @memberof Region
   */
  countryCoordinatorMultiplier?: string
  /**
   * Indicates whether this region matches the user's current session region.
   * @type boolean
   * @memberof Region
   */
  isUserRegion?: boolean
}

export function RegionFromJSON(json: any): Region {
  return RegionFromJSONTyped(json, false)
}

export function RegionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Region {
  if (json === undefined || json === null) {
    return json
  }
  return {
    regionsKey: json['regionsKey'],
    name: json['name'],
    currency: json['currency'],
    cycle: !exists(json, 'cycle') ? undefined : json['cycle'],
    semesterOneStartMonth: json['semesterOneStartMonth'],
    semesterOneStartDay: json['semesterOneStartDay'],
    semesterTwoStartMonth: json['semesterTwoStartMonth'],
    semesterTwoStartDay: json['semesterTwoStartDay'],
    parentRegionsKey: !exists(json, 'parentRegionsKey')
      ? undefined
      : json['parentRegionsKey'],
    parentRegionName: !exists(json, 'parentRegionName')
      ? undefined
      : json['parentRegionName'],
    isPrivate: json['isPrivate'],
    actorKey: !exists(json, 'actorKey') ? undefined : json['actorKey'],
    regionManagerName: json['regionManagerName'],
    bypassAutomatedAgreements: json['bypassAutomatedAgreements'],
    discourseUrl: json['discourseUrl'],
    aYCycleStartYear: json['AYCycleStartYear'],
    achAllowed: !exists(json, 'achAllowed') ? undefined : json['achAllowed'],
    s1LicensingDueOffset: json['S1LicensingDueOffset'],
    s1LicensingLateOffset: json['S1LicensingLateOffset'],
    s2LicensingDueOffset: json['S2LicensingDueOffset'],
    s2LicensingLateOffset: json['S2LicensingLateOffset'],
    countryCoordinatorMultiplier: !exists(json, 'countryCoordinatorMultiplier')
      ? undefined
      : json['countryCoordinatorMultiplier'],
    isUserRegion: !exists(json, 'isUserRegion')
      ? undefined
      : json['isUserRegion'],
  }
}

export function RegionToJSON(value?: Region | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    regionsKey: value.regionsKey,
    name: value.name,
    currency: value.currency,
    cycle: value.cycle,
    semesterOneStartMonth: value.semesterOneStartMonth,
    semesterOneStartDay: value.semesterOneStartDay,
    semesterTwoStartMonth: value.semesterTwoStartMonth,
    semesterTwoStartDay: value.semesterTwoStartDay,
    parentRegionsKey: value.parentRegionsKey,
    parentRegionName: value.parentRegionName,
    isPrivate: value.isPrivate,
    actorKey: value.actorKey,
    regionManagerName: value.regionManagerName,
    bypassAutomatedAgreements: value.bypassAutomatedAgreements,
    discourseUrl: value.discourseUrl,
    AYCycleStartYear: value.aYCycleStartYear,
    achAllowed: value.achAllowed,
    S1LicensingDueOffset: value.s1LicensingDueOffset,
    S1LicensingLateOffset: value.s1LicensingLateOffset,
    S2LicensingDueOffset: value.s2LicensingDueOffset,
    S2LicensingLateOffset: value.s2LicensingLateOffset,
    countryCoordinatorMultiplier: value.countryCoordinatorMultiplier,
    isUserRegion: value.isUserRegion,
  }
}
